import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, baseQueryWithReauth } from "../api.config";

export const authApi = createApi({
  reducerPath: "authApi",
  // Use baseQueryWithReauth so /auth/check transparently refreshes the
  // access token when it expires. Without this, a 15-minute idle period
  // would cause the very next navigation to log the user out — because
  // ProtectedRoute re-runs checkAuth on every navigation and on 401
  // it (correctly) clears the session. With baseQueryWithReauth, the
  // 401 gets intercepted and the refresh token mints a new access
  // token before the error propagates.
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    login: build.mutation({
      query: (data) => ({
        url: `auth/login`,
        method: "POST",
        body: data,
      }),
    }),

    // google login or register api
    googleLogin: build.mutation({
      query: (data) => ({
        url: `auth/google-login`,
        method: "POST",
        body: data,
      }),
    }),

    signUp: build.mutation({
      query: (data) => ({
        url: `auth/signup`,
        method: "POST",
        body: data,
      }),
    }),

    checkAuth: build.query({
      query: ({type}) => ({
        url: `auth/check?type=${type}`,
        method: "GET",
      }),
    }),

    forgotPassword: build.mutation({
      query: (data) => ({
        url: `auth/forgot-password`,
        method: "POST",
        body: data,
      }),
    }),

    verifyResetToken: build.mutation({
      query: (data) => ({
        url: `auth/verify-reset-token`,
        method: "POST",
        body: data,
      }),
    }),

    resetPassword: build.mutation({
      query: (data) => ({
        url: `auth/reset-password`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useGoogleLoginMutation,
  useLazyCheckAuthQuery,
  useSignUpMutation,
  useForgotPasswordMutation,
  useVerifyResetTokenMutation,
  useResetPasswordMutation,
} = authApi;
